var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.reactiveData.items,"multiple":_vm.multiple,"label":_vm.label,"loading":_vm.reactiveData.loading,"return-object":_vm.isObject,"item-value":"id","item-text":_vm.text},on:{"change":_vm.dataChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }